import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@components-clean/core/button';
import Card from '@components-clean/core/card';
import Grid from '@components-clean/core/grid-fe';
import TabStripLowDom from '@components-clean/core/tabstrip-low-dom';
import { GridColumns } from '@pages-clean/dummy-page/pages/persistent-grid-poc/columns';
import { GridData } from '@pages-clean/dummy-page/pages/persistent-grid-poc/data';

const PersistentGridPocPage = () => {
    const DATA_ITEM_KEY: string = 'ProductID';
    const STORAGE_KEY: string = 'PersistentStateGridPoCGridState';

    return (
        <>
            <Card data-testid="persistent-grid-poc-card" title="PoC Details" style={{ marginBottom: '1rem' }}>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '3rem' }}>
                    <div>
                        <div>Persisted In State:</div>
                        <ul>
                            <li>Column Resizing</li>
                            <li>Full Column Re-ordering</li>
                            <li>Column Sorting</li>
                            <li>Basic Filtering</li>
                            <li>Hiding Columns</li>
                            <li>Locking Columns</li>
                        </ul>
                    </div>
                    <div>
                        <div>Not implemented:</div>
                        <ul>
                            <li>
                                Row Re-ordering{' '}
                                <span title="Not sure if we want to store this in state?">
                                    <FontAwesomeIcon icon={['fal', 'circle-exclamation']} />
                                </span>
                            </li>
                            <li>
                                Advanced filtering {/* eslint-disable-next-line max-len */}
                                <span title="This will currently crash the screen if applied, you must then manually remove the state from local storage and refresh the screen.">
                                    <FontAwesomeIcon icon={['fal', 'circle-exclamation']} />
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </Card>

            <TabStripLowDom
                data={[
                    {
                        title: 'Grid',
                        content: (
                            <Grid
                                title="Persistent State Grid"
                                maxHeight="auto"
                                testDataId="persistent-poc-grid"
                                dataItemKey={DATA_ITEM_KEY}
                                data={GridData}
                                columns={GridColumns}
                                canEdit={false}
                                persistentStorageKey={STORAGE_KEY}
                            />
                        ),
                        dataTestId: 'persistent-poc-grid-tab',
                    },
                    {
                        title: 'Tab here and back to redraw grid',
                        content: (
                            <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                                <div>Optionally reset table back to original state:</div>
                                <Button
                                    data-testid="persistent-poc-grid-clear"
                                    onClick={() => {
                                        // eslint-disable-next-line no-restricted-globals
                                        localStorage.removeItem(STORAGE_KEY);
                                    }}
                                    primary
                                >
                                    Clear Persistent State
                                </Button>
                            </div>
                        ),
                        dataTestId: 'persistent-poc-grid-tab-2',
                    },
                ]}
            />
        </>
    );
};

export default PersistentGridPocPage;
